module.exports = `${require.publicPath}yuy.aa5c5583.mp3`;